import React from 'react';
import '../style/Loader.css';

export default function Loader() {
      //console.log("Loader rendered");
  return (
    <div className="loader-overlay">
      <div className="loader-spinner"></div>
    </div>
  );
}
